import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import CompanyAdminProvider from "../contexts/companyAdmin";
import { currentUser, isAuthenticated } from "../helpers";
import { GetMultiStepper } from "../service/authApi";

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = currentUser();

  const [toggleActive, setActive] = useState(false);
  const toggleHandler = () => {
    setActive(!toggleActive);
  };

  const checkStep = async () => {
    try {
      const response = await GetMultiStepper(userInfo?.userId);
      if (response.data.multiStepper === false) {
        navigate("/signup-flow/create-job");
      } else if (response.data.addUser === false) {
        navigate("/signup-flow/add-user");
      } else return;
    } catch (error) {
      console.error("Error fetching multi-stepper data:", error);
    }
  };
  useEffect(() => {
    if (!isAuthenticated()) setTimeout(() => navigate("/login"), 500);
    if (userInfo?.userRole === "CompanyAdmin") {
      checkStep();
    }
  }, [location]);
  return (
    <CompanyAdminProvider>
      <div
        className={`${toggleActive ? "toggleactive main mt-4" : "main mt-4"}  `}
      >
        <div className="left-section position-relative">
          <Sidebar toggleHandler={toggleHandler} toggleActive={toggleActive} />
        </div>
        <div className="right-section ">
          <Header toggleHandler={toggleHandler} toggleActive={toggleActive} />
          <div className="content-wrapper ">
            <div className="Wrapper">
              <Outlet />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </CompanyAdminProvider>
  );
}
